import { render, staticRenderFns } from "./FormTab.vue?vue&type=template&id=eddd4afa&"
import script from "./FormTab.vue?vue&type=script&lang=js&"
export * from "./FormTab.vue?vue&type=script&lang=js&"
import style0 from "./FormTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VTab})
